import { NgModule } from '@angular/core';
import { AuthService } from './auth.service';
import { UserService } from './user.service';
import { Diagnostic } from '@awesome-cordova-plugins/diagnostic/ngx';
import { TokenStoreService } from './token-store.service';
import { Geolocation } from '@awesome-cordova-plugins/geolocation/ngx';
import { NotificationService } from './notification.service';
import { ErrorHandlerService } from './error-handler.service';
import { NativeGeocoder } from '@awesome-cordova-plugins/native-geocoder/ngx';
import { PushSubscriptionService } from './push-subscription.service';
import { RequestInterceptorService } from './request-interceptor.service';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { AndroidPermissions } from '@awesome-cordova-plugins/android-permissions/ngx';
import { OpenNativeSettings } from '@awesome-cordova-plugins/open-native-settings/ngx';

@NgModule({
    imports: [
        HttpClientModule
    ],
    providers: [
        Diagnostic,
        AndroidPermissions,
        OpenNativeSettings,
        UserService,
        AuthService,
        TokenStoreService,
        ErrorHandlerService,
        NotificationService,
        PushSubscriptionService,
        NativeGeocoder,
        Geolocation,
        // { provide: InAppService, deps: [Platform, InAppPurchase2] },
        { provide: HTTP_INTERCEPTORS, useClass: RequestInterceptorService, multi: true },
    ],
    exports: [
        HttpClientModule
    ]
})
export class ServicesModule {
}
